import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, renderSlot as _renderSlot, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ec8e5b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-cy-inner"]
const _hoisted_3 = ["aria-expanded", "aria-controls", "id"]
const _hoisted_4 = { class: "accordion-icon" }
const _hoisted_5 = {
  class: "icon_text",
  style: {"font-weight":"normal"}
}
const _hoisted_6 = ["id"]
const _hoisted_7 = {
  key: 0,
  class: "pb-8 pt-3 px-5"
}
const _hoisted_8 = { class: "container px-6" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "alert-body" }
const _hoisted_11 = { class: "alert-heading" }
const _hoisted_12 = { class: "alert-text" }
const _hoisted_13 = ["data-cy"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "row mb-7"
}
const _hoisted_16 = {
  class: "col",
  "data-cy-name": "Beskrivelse"
}
const _hoisted_17 = {
  class: "col",
  "data-cy-name": "Felt2"
}
const _hoisted_18 = {
  class: "col",
  "data-cy-name": "Felt3"
}
const _hoisted_19 = {
  class: "col",
  "data-cy-name": "Felt4"
}
const _hoisted_20 = {
  class: "col",
  "data-cy-name": "Felt5"
}
const _hoisted_21 = {
  key: 2,
  class: "row mb-7"
}
const _hoisted_22 = {
  class: "col",
  "data-cy-name": "Scope1"
}
const _hoisted_23 = {
  class: "col",
  "data-cy-name": "Scope2"
}
const _hoisted_24 = {
  class: "col",
  "data-cy-name": "Scope3"
}
const _hoisted_25 = {
  class: "col",
  "data-cy-name": "UdledningIAlt"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = ["for"]
const _hoisted_28 = ["id"]
const _hoisted_29 = {
  class: "col",
  "data-cy-name": "UdenforScopes"
}
const _hoisted_30 = {
  key: 3,
  style: {"padding-bottom":"20px"}
}
const _hoisted_31 = {
  key: 1,
  class: "esg-inputs-box"
}
const _hoisted_32 = { class: "container px-6" }
const _hoisted_33 = { class: "row mb-5" }
const _hoisted_34 = {
  class: "col",
  "data-cy-name": "esg-desc"
}
const _hoisted_35 = { class: "ml-2" }
const _hoisted_36 = { class: "row mb-5" }
const _hoisted_37 = {
  class: "col",
  "data-cy-name": "FossilShare"
}
const _hoisted_38 = {
  class: "col",
  "data-cy-name": "NuclearShare"
}
const _hoisted_39 = {
  class: "col",
  "data-cy-name": "RenewableShare"
}
const _hoisted_40 = {
  class: "col",
  "data-cy-name": "EsgConversion"
}
const _hoisted_41 = {
  key: 4,
  class: "row mb-5"
}
const _hoisted_42 = {
  class: "col-1",
  style: {"max-width":"30%","flex-basis":"30%","padding":"0 11px"},
  "data-cy-name": "Scope3Kategori"
}
const _hoisted_43 = {
  class: "col-8",
  style: {"max-width":"40%","flex-basis":"40%","padding":"0 11px"},
  "data-cy-name": "Bemaerkninger"
}
const _hoisted_44 = {
  key: 0,
  class: "form-group"
}
const _hoisted_45 = ["for"]
const _hoisted_46 = { class: "weight-normal" }
const _hoisted_47 = ["id", "disabled"]
const _hoisted_48 = { class: "col" }
const _hoisted_49 = { class: "form-group file-input" }
const _hoisted_50 = { enctype: "multipart/form-data" }
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "weight-normal" }
const _hoisted_53 = ["id"]
const _hoisted_54 = { class: "row mb-4 mt-1" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = ["id", "disabled"]
const _hoisted_57 = {
  key: 0,
  class: "file-list"
}
const _hoisted_58 = ["disabled", "onClick"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  focusable: "false",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#trash-can" })
], -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "row align-items-end mb-5" }
const _hoisted_62 = ["id", "disabled"]
const _hoisted_63 = { class: "button-text" }
const _hoisted_64 = ["id", "disabled"]
const _hoisted_65 = { class: "button-text" }
const _hoisted_66 = {
  key: 2,
  class: "alert alert-info alert--show-icon mb-0 mt-0 ml-5",
  role: "alert",
  "aria-atomic": "true"
}
const _hoisted_67 = { class: "alert-body" }
const _hoisted_68 = { class: "alert-heading" }
const _hoisted_69 = { class: "alert-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_GenericInput = _resolveComponent("GenericInput")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_GenericTableComponent = _resolveComponent("GenericTableComponent")!
  const _component_CypressTestElement = _resolveComponent("CypressTestElement")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("ul", {
    class: "accordion my-405",
    id: 'calculatorInput' + _ctx.subgroupingId
  }, [
    _createElementVNode("li", {
      class: "mb-0",
      "data-cy-inner": 'calculator_' + _ctx.subgroupingId
    }, [
      _createElementVNode("button", {
        class: "accordion-button",
        "aria-expanded": _ctx.expanded || _ctx.isReadOnly || _ctx.isTestFramework,
        "aria-controls": `calculator-${_ctx.subgroupingId}`,
        id: 'calculator-section-' + _ctx.subgroupingId
      }, [
        _createTextVNode(_toDisplayString(_ctx.title?.toUpperCase()) + " ", 1),
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.totalEmissionTitle) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.doPrettify(_ctx.calculationList.reduce((sum, cur) => sum + Number(_ctx.calculateTotalEmission(cur)), 0).toFixed(2))), 1),
            _withDirectives(_createElementVNode("span", null, null, 512), [
              [_directive_dompurify_html, _ctx.tonsCo2E]
            ])
          ])
        ])
      ], 8, _hoisted_3),
      _createElementVNode("div", {
        id: `calculator-${_ctx.subgroupingId}`,
        "aria-hidden": "true",
        class: _normalizeClass(["accordion-content px-0 pb-0", { 'pt-8': !_ctx.tooltip }])
      }, [
        (_ctx.tooltip)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, null, 512)), [
              [_directive_dompurify_html, _ctx.tooltip]
            ])
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onChange: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.formValidation.clearValidField && _ctx.formValidation.clearValidField(...args))),
          onSubmit: _cache[35] || (_cache[35] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
          onInvalidCapture: _cache[36] || (_cache[36] = _withModifiers(($event: any) => {_ctx.formValidation.handleFormValidity($event, false); _ctx.focusFirstError(_ctx.formValidation)}, ["prevent"])),
          class: _normalizeClass({ 'do-not-print': _ctx.basisModule })
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.formValidation.formErrors.size)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "alert alert-error",
                  role: "alert",
                  "aria-atomic": "true",
                  ref: "formErrorsAlert",
                  id: `calculator-${_ctx.subgroupingId}-errors`
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, [
                      _createVNode(_component_SimpleText, { "text-key": "sharedContent.formErrorTitle" })
                    ]),
                    _createElementVNode("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: key,
                          "data-cy": 'error_' + key
                        }, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: _withModifiers(($event: any) => (_ctx.focusInput(key)), ["prevent"]),
                            style: {"text-decoration":"none"}
                          }, _toDisplayString(value), 9, _hoisted_14)
                        ], 8, _hoisted_13))
                      }), 128))
                    ])
                  ])
                ], 8, _hoisted_9))
              : _createCommentVNode("", true),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.renderedFields[0])
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.fields[0].id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.fields[0].id}`,
                          ref: "field0",
                          modelValue: _ctx.renderedFields[0].value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.renderedFields[0].value) = $event)),
                          disabled: _ctx.isReadOnly,
                          doubleLineHeight: true,
                          lable: _ctx.renderedFields[0].lable,
                          max: _ctx.renderedFields[0].maximumValue,
                          min: _ctx.renderedFields[0].minimumValue,
                          possibleValues: _ctx.renderedFields[0].possibleValues,
                          regex: _ctx.findRegexPattern(_ctx.renderedFields[0].validationRegex),
                          required: _ctx.renderedFields[0].required,
                          step: _ctx.renderedFields[0].step,
                          tooltip: _ctx.renderedFields[0].tooltip,
                          type: _ctx.renderedFields[0].valueType,
                          validationError: _ctx.renderedFields[0].error
                        }, null, 8, ["id", "cy-id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "regex", "required", "step", "tooltip", "type", "validationError"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _renderSlot(_ctx.$slots, "basecalculator-row-1-col-2", {
                      setSelectedDependent: _ctx.setSelectedDependent,
                      unitValueChanged: _ctx.unitValueChanged,
                      applyConditions: _ctx.applyConditions,
                      applyValidationError: _ctx.applyValidationError,
                      applyValidationOk: _ctx.applyValidationOk,
                      setCalculationChanged: _ctx.setCalculationChanged,
                      fields: _ctx.renderedFields,
                      isReadOnly: _ctx.isReadOnly
                    }, undefined, true)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _renderSlot(_ctx.$slots, "basecalculator-row-1-col-3", {
                      setSelectedDependent: _ctx.setSelectedDependent,
                      unitValueChanged: _ctx.unitValueChanged,
                      applyConditions: _ctx.applyConditions,
                      applyValidationError: _ctx.applyValidationError,
                      applyValidationOk: _ctx.applyValidationOk,
                      setCalculationChanged: _ctx.setCalculationChanged,
                      fields: _ctx.renderedFields,
                      isReadOnly: _ctx.isReadOnly
                    }, undefined, true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _renderSlot(_ctx.$slots, "basecalculator-row-1-col-4", {
                      setSelectedDependent: _ctx.setSelectedDependent,
                      unitValueChanged: _ctx.unitValueChanged,
                      applyConditions: _ctx.applyConditions,
                      applyValidationError: _ctx.applyValidationError,
                      applyValidationOk: _ctx.applyValidationOk,
                      setCalculationChanged: _ctx.setCalculationChanged,
                      fields: _ctx.renderedFields,
                      isReadOnly: _ctx.isReadOnly
                    }, undefined, true)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _renderSlot(_ctx.$slots, "basecalculator-row-1-col-5", {
                      setSelectedDependent: _ctx.setSelectedDependent,
                      unitValueChanged: _ctx.unitValueChanged,
                      applyConditions: _ctx.applyConditions,
                      applyValidationError: _ctx.applyValidationError,
                      applyValidationOk: _ctx.applyValidationOk,
                      setCalculationChanged: _ctx.setCalculationChanged,
                      biofuelInput: _ctx.biofuelInput,
                      fields: _ctx.renderedFields,
                      isReadOnly: _ctx.isReadOnly
                    }, undefined, true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isReadOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.scopeFields[0])
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[0].id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[0].id}`,
                          modelValue: _ctx.scopeFields[0].value,
                          "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.scopeFields[0].value) = $event)),
                            _ctx.applyConditions
                          ],
                          disabled: !_ctx.scopeFields[0].valueType.includes('OWN') || _ctx.isReadOnly,
                          lable: _ctx.scopeFields[0].lable,
                          max: _ctx.scopeFields[0].maximumValue,
                          min: _ctx.scopeFields[0].minimumValue,
                          regex: _ctx.findRegexPattern(_ctx.scopeFields[0].validationRegex),
                          required: _ctx.scopeFields[0].required,
                          step: _ctx.scopeFields[0].step,
                          tooltip: this.getTooltip(_ctx.scopeFields[0].tooltip, _ctx.scopeFields[0].contentfulId),
                          type: _ctx.scopeFields[0].valueType,
                          validationError: _ctx.scopeFields[0].error,
                          doubleLineHeight: true,
                          onValueInvalid: _cache[2] || (_cache[2] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                          onValueValid: _cache[3] || (_cache[3] = (arg1) => _ctx.applyValidationOk(arg1)),
                          onInput: _ctx.setCalculationChanged,
                          onFocusout: _ctx.setCalculationChanged
                        }, null, 8, ["id", "cy-id", "modelValue", "disabled", "lable", "max", "min", "regex", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.scopeFields[1])
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[1].id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[1].id}`,
                          modelValue: _ctx.scopeFields[1].value,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => ((_ctx.scopeFields[1].value) = $event)),
                            _ctx.applyConditions
                          ],
                          disabled: !_ctx.scopeFields[1].valueType.includes('OWN') || _ctx.isReadOnly,
                          lable: _ctx.scopeFields[1].lable,
                          max: _ctx.scopeFields[1].maximumValue,
                          min: _ctx.scopeFields[1].minimumValue,
                          regex: _ctx.findRegexPattern(_ctx.scopeFields[1].validationRegex),
                          required: _ctx.scopeFields[1].required,
                          step: _ctx.scopeFields[1].step,
                          tooltip: this.getTooltip(_ctx.scopeFields[1].tooltip, _ctx.scopeFields[1].contentfulId),
                          type: _ctx.scopeFields[1].valueType,
                          validationError: _ctx.scopeFields[1].error,
                          doubleLineHeight: true,
                          onValueInvalid: _cache[5] || (_cache[5] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                          onValueValid: _cache[6] || (_cache[6] = (arg1) => _ctx.applyValidationOk(arg1)),
                          onInput: _ctx.setCalculationChanged,
                          onFocusout: _ctx.setCalculationChanged
                        }, null, 8, ["id", "cy-id", "modelValue", "disabled", "lable", "max", "min", "regex", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    (_ctx.scopeFields[2] && !_ctx.basisModule)
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[2].id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[2].id}`,
                          modelValue: _ctx.scopeFields[2].value,
                          "onUpdate:modelValue": [
                            _cache[7] || (_cache[7] = ($event: any) => ((_ctx.scopeFields[2].value) = $event)),
                            _ctx.applyConditions
                          ],
                          disabled: !_ctx.scopeFields[2].valueType.includes('OWN') || _ctx.isReadOnly,
                          lable: _ctx.scopeFields[2].lable,
                          max: _ctx.scopeFields[2].maximumValue,
                          min: _ctx.scopeFields[2].minimumValue,
                          regex: _ctx.findRegexPattern(_ctx.scopeFields[2].validationRegex),
                          required: _ctx.scopeFields[2].required,
                          step: _ctx.scopeFields[2].step,
                          tooltip: this.getTooltip(_ctx.scopeFields[2].tooltip, _ctx.scopeFields[2].contentfulId),
                          type: _ctx.scopeFields[2].valueType,
                          validationError: _ctx.scopeFields[2].error,
                          doubleLineHeight: true,
                          onValueInvalid: _cache[8] || (_cache[8] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                          onValueValid: _cache[9] || (_cache[9] = (arg1) => _ctx.applyValidationOk(arg1)),
                          onInput: _ctx.setCalculationChanged,
                          onFocusout: _ctx.setCalculationChanged
                        }, null, 8, ["id", "cy-id", "modelValue", "disabled", "lable", "max", "min", "regex", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _withDirectives(_createElementVNode("label", {
                        for: `calculator-${_ctx.subgroupingId}-total-emission-field`,
                        class: "form-label double-line-height"
                      }, null, 8, _hoisted_27), [
                        [_directive_dompurify_html, _ctx.totalEmissionLabel]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        id: `calculator-${_ctx.subgroupingId}-total-emission-field`,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.totalEmission) = $event)),
                        class: "form-input",
                        disabled: "",
                        name: "input-type-text",
                        style: {"text-align":"right"},
                        type: "text"
                      }, null, 8, _hoisted_28), [
                        [_vModelText, _ctx.totalEmission]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.scopeFields[3] && !_ctx.basisModule)
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[3].id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.scopeFields[3].id}`,
                          modelValue: _ctx.scopeFields[3].value,
                          "onUpdate:modelValue": [
                            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.scopeFields[3].value) = $event)),
                            _ctx.applyConditions
                          ],
                          disabled: !_ctx.scopeFields[3].valueType.includes('OWN') || _ctx.isReadOnly,
                          lable: _ctx.scopeFields[3].lable,
                          max: _ctx.scopeFields[3].maximumValue,
                          min: _ctx.scopeFields[3].minimumValue,
                          possibleValues: _ctx.scopeFields[3].possibleValues,
                          regex: _ctx.findRegexPattern(_ctx.scopeFields[3].validationRegex),
                          required: _ctx.scopeFields[3].required,
                          step: _ctx.scopeFields[3].step,
                          tooltip: this.getTooltip(_ctx.scopeFields[3].tooltip, _ctx.scopeFields[3].contentfulId),
                          type: _ctx.scopeFields[3].valueType,
                          validationError: _ctx.scopeFields[3].error,
                          doubleLineHeight: true,
                          onValueInvalid: _cache[12] || (_cache[12] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                          onValueValid: _cache[13] || (_cache[13] = (arg1) => _ctx.applyValidationOk(arg1)),
                          onInput: _ctx.setCalculationChanged,
                          onFocusout: _ctx.setCalculationChanged
                        }, null, 8, ["id", "cy-id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "regex", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isEsgOwnEmissionFactors && !_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_ctx.esgManualFields[0])
                    ? (_openBlock(), _createBlock(_component_GenericInput, {
                        key: 0,
                        id: `calculator-${_ctx.subgroupingId}-field-${_ctx.esgManualFields[0].id}`,
                        modelValue: _ctx.esgManualFields[0].value,
                        "onUpdate:modelValue": [
                          _cache[14] || (_cache[14] = ($event: any) => ((_ctx.esgManualFields[0].value) = $event)),
                          _ctx.setUseInEsg
                        ],
                        disabled: _ctx.isReadOnly,
                        lable: _ctx.esgManualFields[0].lable,
                        max: _ctx.esgManualFields[0].maximumValue,
                        min: _ctx.esgManualFields[0].minimumValue,
                        possibleValues: _ctx.esgManualFields[0].possibleValues,
                        required: _ctx.esgManualFields[0].required,
                        step: _ctx.esgManualFields[0].step,
                        tooltip: this.getTooltip(_ctx.esgManualFields[0].tooltip, _ctx.esgManualFields[0].contentfulId),
                        type: _ctx.esgManualFields[0].valueType,
                        validationError: _ctx.esgManualFields[0].error,
                        doubleLineHeight: true,
                        onValueInvalid: _cache[15] || (_cache[15] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                        onValueValid: _cache[16] || (_cache[16] = (arg1) => _ctx.applyValidationOk(arg1)),
                        onInput: _ctx.setCalculationChanged,
                        onFocusout: _ctx.setCalculationChanged
                      }, null, 8, ["id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                    : _createCommentVNode("", true),
                  (_ctx.useInEsg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_SimpleText, { "text-key": "esg.input.description" }),
                              _createElementVNode("span", _hoisted_35, [
                                _createVNode(_component_Tooltip, {
                                  text: _ctx.getContentfulString('esg.input.tooltip')
                                }, null, 8, ["text"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              (_ctx.esgManualFields[1])
                                ? (_openBlock(), _createBlock(_component_GenericInput, {
                                    key: 0,
                                    id: `calculator-${_ctx.subgroupingId}-field-${_ctx.esgManualFields[1].id}`,
                                    modelValue: _ctx.esgManualFields[1].value,
                                    "onUpdate:modelValue": [
                                      _cache[17] || (_cache[17] = ($event: any) => ((_ctx.esgManualFields[1].value) = $event)),
                                      _ctx.applyConditions
                                    ],
                                    disabled: _ctx.isReadOnly,
                                    lable: _ctx.esgManualFields[1].lable,
                                    max: _ctx.esgManualFields[1].maximumValue,
                                    min: _ctx.esgManualFields[1].minimumValue,
                                    possibleValues: _ctx.esgManualFields[1].possibleValues,
                                    required: _ctx.esgManualFields[1].required,
                                    step: _ctx.esgManualFields[1].step,
                                    tooltip: this.getTooltip(_ctx.esgManualFields[1].tooltip, _ctx.esgManualFields[1].contentfulId),
                                    type: _ctx.esgManualFields[1].valueType,
                                    "allowed-decimals": "4",
                                    validationError: _ctx.esgManualFields[1].error,
                                    doubleLineHeight: false,
                                    onValueInvalid: _cache[18] || (_cache[18] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                                    onValueValid: _cache[19] || (_cache[19] = (arg1) => _ctx.applyValidationOk(arg1)),
                                    onInput: _ctx.setCalculationChanged,
                                    onFocusout: _ctx.setCalculationChanged
                                  }, null, 8, ["id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_38, [
                              (_ctx.esgManualFields[2])
                                ? (_openBlock(), _createBlock(_component_GenericInput, {
                                    key: 0,
                                    id: `calculator-${_ctx.subgroupingId}-field-${_ctx.esgManualFields[2].id}`,
                                    modelValue: _ctx.esgManualFields[2].value,
                                    "onUpdate:modelValue": [
                                      _cache[20] || (_cache[20] = ($event: any) => ((_ctx.esgManualFields[2].value) = $event)),
                                      _ctx.applyConditions
                                    ],
                                    disabled: _ctx.isReadOnly,
                                    lable: _ctx.esgManualFields[2].lable,
                                    max: _ctx.esgManualFields[2].maximumValue,
                                    min: _ctx.esgManualFields[2].minimumValue,
                                    possibleValues: _ctx.esgManualFields[2].possibleValues,
                                    required: _ctx.esgManualFields[2].required,
                                    step: _ctx.esgManualFields[2].step,
                                    tooltip: this.getTooltip(_ctx.esgManualFields[2].tooltip, _ctx.esgManualFields[2].contentfulId),
                                    type: _ctx.esgManualFields[2].valueType,
                                    "allowed-decimals": "4",
                                    validationError: _ctx.esgManualFields[2].error,
                                    doubleLineHeight: false,
                                    onValueInvalid: _cache[21] || (_cache[21] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                                    onValueValid: _cache[22] || (_cache[22] = (arg1) => _ctx.applyValidationOk(arg1)),
                                    onInput: _ctx.setCalculationChanged,
                                    onFocusout: _ctx.setCalculationChanged
                                  }, null, 8, ["id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              (_ctx.esgManualFields[3])
                                ? (_openBlock(), _createBlock(_component_GenericInput, {
                                    key: 0,
                                    id: `calculator-${_ctx.subgroupingId}-field-${_ctx.esgManualFields[3].id}`,
                                    modelValue: _ctx.esgManualFields[3].value,
                                    "onUpdate:modelValue": [
                                      _cache[23] || (_cache[23] = ($event: any) => ((_ctx.esgManualFields[3].value) = $event)),
                                      _ctx.applyConditions
                                    ],
                                    disabled: _ctx.isReadOnly,
                                    lable: _ctx.esgManualFields[3].lable,
                                    max: _ctx.esgManualFields[3].maximumValue,
                                    min: _ctx.esgManualFields[3].minimumValue,
                                    possibleValues: _ctx.esgManualFields[3].possibleValues,
                                    required: _ctx.esgManualFields[3].required,
                                    step: _ctx.esgManualFields[3].step,
                                    tooltip: this.getTooltip(_ctx.esgManualFields[3].tooltip, _ctx.esgManualFields[3].contentfulId),
                                    type: _ctx.esgManualFields[3].valueType,
                                    "allowed-decimals": "4",
                                    validationError: _ctx.esgManualFields[3].error,
                                    doubleLineHeight: false,
                                    onValueInvalid: _cache[24] || (_cache[24] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                                    onValueValid: _cache[25] || (_cache[25] = (arg1) => _ctx.applyValidationOk(arg1)),
                                    onInput: _ctx.setCalculationChanged,
                                    onFocusout: _ctx.setCalculationChanged
                                  }, null, 8, ["id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_40, [
                              (_ctx.esgManualFields[4])
                                ? (_openBlock(), _createBlock(_component_GenericInput, {
                                    key: 0,
                                    id: `calculator-${_ctx.subgroupingId}-field-${_ctx.esgManualFields[4].id}`,
                                    modelValue: _ctx.esgManualFields[4].value,
                                    "onUpdate:modelValue": [
                                      _cache[26] || (_cache[26] = ($event: any) => ((_ctx.esgManualFields[4].value) = $event)),
                                      _ctx.applyConditions
                                    ],
                                    disabled: _ctx.isReadOnly || _ctx.esgManualFields[4].isEnabled === false,
                                    lable: _ctx.esgManualFields[4].lable,
                                    max: _ctx.esgManualFields[4].maximumValue,
                                    min: _ctx.esgManualFields[4].minimumValue,
                                    possibleValues: _ctx.esgManualFields[4].possibleValues,
                                    required: _ctx.esgManualFields[4].required,
                                    step: _ctx.esgManualFields[4].step,
                                    tooltip: this.getTooltip(_ctx.esgManualFields[4].tooltip, _ctx.esgManualFields[4].contentfulId),
                                    type: _ctx.esgManualFields[4].valueType,
                                    "allowed-decimals": "5",
                                    validationError: _ctx.esgManualFields[4].error,
                                    doubleLineHeight: false,
                                    onValueInvalid: _cache[27] || (_cache[27] = (arg1, arg2) => _ctx.applyValidationError(arg1, arg2)),
                                    onValueValid: _cache[28] || (_cache[28] = (arg1) => _ctx.applyValidationOk(arg1)),
                                    onInput: _ctx.setCalculationChanged,
                                    onFocusout: _ctx.setCalculationChanged
                                  }, null, 8, ["id", "modelValue", "disabled", "lable", "max", "min", "possibleValues", "required", "step", "tooltip", "type", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isReadOnly   && !_ctx.basisModule)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    (_ctx.scope3category)
                      ? (_openBlock(), _createBlock(_component_GenericInput, {
                          key: 0,
                          id: `calculator-${_ctx.subgroupingId}-field-${_ctx.scope3category.id}`,
                          "cy-id": `calculator-${_ctx.subgroupingId}-field-${_ctx.scope3category.id}`,
                          modelValue: _ctx.scope3category.value,
                          "onUpdate:modelValue": [
                            _cache[29] || (_cache[29] = ($event: any) => ((_ctx.scope3category.value) = $event)),
                            _ctx.applyConditions
                          ],
                          lable: this.scope3categoryLabel,
                          possibleValues: _ctx.scope3category.possibleValues,
                          required: true,
                          disabled: false,
                          tooltip: _ctx.scope3category.tooltip,
                          type: 'DROPDOWN',
                          validationError: _ctx.scope3category.error,
                          onInput: _ctx.setCalculationChanged,
                          onFocusout: _ctx.setCalculationChanged
                        }, null, 8, ["id", "cy-id", "modelValue", "lable", "possibleValues", "tooltip", "validationError", "onUpdate:modelValue", "onInput", "onFocusout"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    (_ctx.remarksField)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("label", {
                            class: "form-label",
                            for: `calculator-${_ctx.subgroupingId}-input-area`
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.remarksField.lable) + " ", 1),
                            _createElementVNode("span", _hoisted_46, [
                              _createVNode(_component_SimpleText, { "text-key": "sharedContent.optionalLabel" })
                            ])
                          ], 8, _hoisted_45),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-input mw-100",
                            rows: "2",
                            id: `calculator-${_ctx.subgroupingId}-input-area`,
                            name: "input-area",
                            maxlength: "500",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.remarksField.value) = $event)),
                            disabled: _ctx.isReadOnly
                          }, null, 8, _hoisted_47), [
                            [
                              _vModelText,
                              _ctx.remarksField.value,
                              void 0,
                              { lazy: true }
                            ]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("form", _hoisted_50, [
                        _createElementVNode("label", {
                          class: "form-label",
                          for: `calculator-${_ctx.subgroupingId}-fileinput`
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.attachFile) + " ", 1),
                          _createElementVNode("span", _hoisted_52, [
                            _createVNode(_component_SimpleText, { "text-key": "sharedContent.optionalLabel" })
                          ])
                        ], 8, _hoisted_51),
                        _createElementVNode("span", {
                          class: "form-hint",
                          id: `calculator-${_ctx.subgroupingId}-fileinput-hint`
                        }, _toDisplayString(_ctx.attachFileHint), 9, _hoisted_53),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("button", {
                              class: "button button-secondary",
                              id: "attach-file-button",
                              onClick: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.dummyUploadFile()), ["prevent"]))
                            }, [
                              _createVNode(_component_SimpleText, { "text-key": "calculation.attach-file-button.name" })
                            ])
                          ])
                        ]),
                        _createElementVNode("input", {
                          style: {"display":"none"},
                          type: "file",
                          id: `calculator-${_ctx.subgroupingId}-fileinput`,
                          name: "file",
                          accept: ".pdf, .jpg, .jpeg, .png",
                          onChange: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.addFile && _ctx.addFile(...args))),
                          disabled: _ctx.isReadOnly
                        }, null, 40, _hoisted_56)
                      ])
                    ]),
                    (_ctx.fileList && _ctx.fileList.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_57, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (file) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: file?.fileName
                            }, [
                              file
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    disabled: _ctx.isReadOnly,
                                    class: "button button-unstyled",
                                    onClick: _withModifiers(($event: any) => (_ctx.deleteFile(file)), ["prevent"])
                                  }, _hoisted_60, 8, _hoisted_58))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(file?.fileName && _ctx.truncate(file.fileName, 40)), 1)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_61, [
              (!_ctx.isReadOnly && !_ctx.calculationChanged || _ctx.isTestFramework)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    ref: "saveButton",
                    id: 'saveButton_'+ _ctx.subgroupingId,
                    disabled: _ctx.working,
                    class: "button button-primary px-6 saveButton",
                    type: "submit"
                  }, [
                    _createElementVNode("span", _hoisted_63, [
                      _createVNode(_component_SimpleText, { "text-key": "sharedContent.save" })
                    ])
                  ], 8, _hoisted_62))
                : _createCommentVNode("", true),
              (!_ctx.isReadOnly && _ctx.calculationChanged || _ctx.isTestFramework)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    id: 'updateCalculationButton_'+ _ctx.subgroupingId,
                    class: "button button-primary px-6",
                    disabled: _ctx.working,
                    onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (_ctx.applyConditions()), ["prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_65, [
                      _createVNode(_component_SimpleText, { "text-key": "sharedContent.calculaterow" })
                    ])
                  ], 8, _hoisted_64))
                : _createCommentVNode("", true),
              (_ctx.showEmissionWarning)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("p", _hoisted_68, [
                        _createVNode(_component_SimpleText, { "text-key": "sharedContent.important" })
                      ]),
                      _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.countryEmissionWarningText), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 34),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genericTables, (table) => {
          return (_openBlock(), _createBlock(_component_GenericTableComponent, {
            id: table.calculateId,
            key: table.calculateId,
            content: table,
            ref_for: true,
            ref: _ctx.setGenericTableComponentRef,
            onEditClick: ($event: any) => (_ctx.editCalculation(table.calculateId)),
            onDeleteClick: ($event: any) => (_ctx.deleteCalculation(table.calculateId)),
            onShowToastAndDelayHide: ($event: any) => (_ctx.showToastAndDelayHide(table.fieldValues?.find((field) => field.id === _ctx.fields[0]?.id)?.value, _ctx.constants.TOAST_TYPE_CALCULATOR_DELETE)),
            basisModule: _ctx.basisModule,
            subgroupingId: _ctx.subgroupingId
          }, null, 8, ["id", "content", "onEditClick", "onDeleteClick", "onShowToastAndDelayHide", "basisModule", "subgroupingId"]))
        }), 128)),
        _createVNode(_component_CypressTestElement, {
          state: _ctx.hasBeenRecalculated,
          inner: _ctx.lastSavedCalculationId,
          identifier: 'cypress_calculator_' + _ctx.subgroupingId
        }, null, 8, ["state", "inner", "identifier"])
      ], 10, _hoisted_6)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}